import React from "react";

export default function CommonFiveTextDetails() {
  return (
    <div className="d-flex flex-wrap align-items-center">
      <p className="font-16-NunitoSans-600 mt-common-card__text-and-icon">
        <img src="/img/desktop/icons/gray-bag-icon.svg" alt="" />
        Time &amp; Material
      </p>
      <p className="font-16-NunitoSans-600 mt-common-card__text-and-icon">
        <img src="/img/desktop/icons/gray-location-icon.svg" alt="" />
        Remote
      </p>
      <p className="font-16-NunitoSans-600 mt-common-card__text-and-icon">
        <img src="/img/desktop/icons/gray-calendar-icon.svg" alt="" />3 Months
      </p>
      <p className="font-16-NunitoSans-600 mt-common-card__text-and-icon">
        <img src="/img/desktop/icons/gray-two-people-icon.svg" alt="" />3
        Resources Required
      </p>
      <p className="font-16-NunitoSans-600 mt-common-card__text-and-icon">
        <img src="/img/desktop/icons/gray-send-icon.svg" alt="" />
        Monthly Billing
      </p>
    </div>
  );
}
